import { cn } from '../../lib/utils';

interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {}

function Table({ className, ...props }: TableProps) {
  return (
    <table
      className={cn('min-w-full divide-y divide-gray-300 dark:divide-gray-700', className)}
      {...props}
    />
  );
}

interface TableHeaderProps extends React.HTMLAttributes<HTMLTableSectionElement> {}

function TableHeader({ className, ...props }: TableHeaderProps) {
  return <thead className={cn('bg-gray-50 dark:bg-gray-800', className)} {...props} />;
}

interface TableBodyProps extends React.HTMLAttributes<HTMLTableSectionElement> {}

function TableBody({ className, ...props }: TableBodyProps) {
  return (
    <tbody
      className={cn(
        'divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900',
        className
      )}
      {...props}
    />
  );
}

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {}

function TableRow({ className, ...props }: TableRowProps) {
  return (
    <tr
      className={cn('hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors', className)}
      {...props}
    />
  );
}

interface TableHeadProps extends React.ThHTMLAttributes<HTMLTableHeaderCellElement> {}

function TableHead({ className, ...props }: TableHeadProps) {
  return (
    <th
      className={cn(
        'px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100',
        'first:pl-4 last:pr-4 first:sm:pl-6 last:sm:pr-6',
        className
      )}
      {...props}
    />
  );
}

interface TableCellProps extends React.TdHTMLAttributes<HTMLTableDataCellElement> {}

function TableCell({ className, ...props }: TableCellProps) {
  return (
    <td
      className={cn(
        'px-3 py-4 text-sm text-gray-900 dark:text-gray-100',
        'first:pl-4 last:pr-4 first:sm:pl-6 last:sm:pr-6',
        className
      )}
      {...props}
    />
  );
}

interface TableContainerProps extends React.HTMLAttributes<HTMLDivElement> {}

function TableContainer({ className, ...props }: TableContainerProps) {
  return (
    <div
      className={cn(
        'overflow-hidden shadow ring-1 ring-black ring-opacity-5 dark:ring-white dark:ring-opacity-10 rounded-lg',
        className
      )}
    >
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full align-middle" {...props} />
      </div>
    </div>
  );
}

export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell, TableContainer };
